// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ***************************************************************** Forgiveness *******************************************************************
const INDEX_FORGIVENESS_SUCCESS = "INDEX_FORGIVENESS_SUCCESS";
const SHOW_FORGIVENESS_SUCCESS = "SHOW_FORGIVENESS_SUCCESS";
const STORE_FORGIVENESS_SUCCESS = "STORE_FORGIVENESS_SUCCESS";
const UPDATE_FORGIVENESS_SUCCESS = "UPDATE_FORGIVENESS_SUCCESS";
const DESTROY_FORGIVENESS_SUCCESS = "DESTROY_FORGIVENESS_SUCCESS";
// ******************************************************************** forgivenessRules **********************************************************************
const INDEX_FORGIVENESS_RULES_SUCCESS = "INDEX_FORGIVENESS_RULES_SUCCESS";
const SHOW_FORGIVENESS_RULE_SUCCESS = "SHOW_FORGIVENESS_RULE_SUCCESS";
const SHOW_FORGIVENESS_EACH_RULE_SUCCESS = "SHOW_FORGIVENESS_EACH_RULE_SUCCESS";
const STORE_FORGIVENESS_RULE_SUCCESS = "STORE_FORGIVENESS_RULE_SUCCESS";
const UPDATE_FORGIVENESS_RULE_SUCCESS = "UPDATE_FORGIVENESS_RULE_SUCCESS";
const DESTROY_FORGIVENESS_RULE_SUCCESS = "DESTROY_FORGIVENESS_RULE_SUCCESS";

const INDEX_FORGIVENESS_RULES_FORM_SUCCESS = "INDEX_FORGIVENESS_RULES_FORM_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ***************************************************************** Forgiveness *******************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexSuccess(payload) {
  return {
    type: INDEX_FORGIVENESS_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showSuccess(payload) {
  return {
    type: SHOW_FORGIVENESS_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showSuccessCustom(payload) {
  return {
    type: SHOW_FORGIVENESS_SUCCESS,
    payload: payload.data.geoFence,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSuccess(payload) {
  return {
    type: STORE_FORGIVENESS_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateSuccess(payload) {
  return {
    type: UPDATE_FORGIVENESS_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroySuccess(payload) {
  return {
    type: DESTROY_FORGIVENESS_SUCCESS,
    payload: payload,
  };
}

// ******************************************************************** forgivenessRules **********************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexForgivenessRulesSuccess(payload) {
  return {
    type: INDEX_FORGIVENESS_RULES_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showForgivenessRuleSuccess(payload) {
  return {
    type: SHOW_FORGIVENESS_RULE_SUCCESS,
    payload: payload.data,
  };
}
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showEachForgivenessRuleSuccess(payload) {
  return {
    type: SHOW_FORGIVENESS_EACH_RULE_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeForgivenessRuleSuccess(payload) {
  return {
    type: STORE_FORGIVENESS_RULE_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateForgivenessRuleSuccess(payload) {
  return {
    type: UPDATE_FORGIVENESS_RULE_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroyForgivenessRuleSuccess(payload) {
  return {
    type: DESTROY_FORGIVENESS_RULE_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showRule(payload) {
  return {
    type: INDEX_FORGIVENESS_RULES_FORM_SUCCESS,
    payload: payload.data,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ***************************************************************** Forgiveness *******************************************************************
/**
 *
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function index(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/ForgivenessPattern/GetAll", { params })
      .then((r) => {
        dispatch(_indexSuccess(r));
        callback(false, r);
      })
      .catch((e) => {
        callback(e);
      });
  };
}

/**
 *
 * @param {Number} forgiveness
 * @param {Object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function show(forgiveness, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`/ForgivenessPattern/GetById/${forgiveness}`)
      .then((r) => {
        dispatch(_showSuccess(r));
        callback(r);
      })
      .catch((e) => {});
  };
}

/**
 *
 * @param {Number} forgiveness
 * @param {Object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function shows(forgiveness, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`/Ta/GeoFences/${forgiveness}`, { params })
      .then((r) => {
        dispatch(_showSuccessCustom(r));
        callback(r);
      })
      .catch((e) => {});
  };
}

/**
 *
 * @param {Number} rule
 * @param {Object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showForm(rule, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`/ta/rules/${rule}`, { params })
      .then((res) => {
        dispatch(_showRule(res));
        callback(undefined, res);
      })
      .catch((err) => {
        app.error(
          err,
          "routes.home.attendance.rules",
          "Rule",
          app.translate(".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید")
        );
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function store(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate(
        "routes.home.attendance.forgiveness.Adding New Forgiveness"
      )
    );

    api
      .post("/ForgivenessPattern/Create",  data )
      .then((r) => {
        dispatch(_storeSuccess(r));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.forgiveness.New Forgiveness Added Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.forgiveness",
            "Forgiveness",
            app.translate(
              "routes.home.attendance.forgiveness.Adding New Forgiveness Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @param {Number} forgiveness
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function update(forgiveness, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.attendance.forgiveness.Updating Forgiveness")
    );

    // Create the correct data structure
    const newData = {
      name: data?.title,
      description: data?.description,
    };

    console.log("newData", newData);

    // Send the PUT request with the correct body data
    api
      .put(`/ForgivenessPattern/Update`, {
        data: {
            id:forgiveness,
            title: data?.title,
            description: data?.description,
          
        },
      }) // <- Use newData directly
      .then((r) => {
        dispatch(_updateSuccess(r));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.forgiveness.Forgiveness Updated Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.forgiveness",
            "Forgiveness",
            app.translate(
              "routes.home.attendance.forgiveness.Updating Forgiveness Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @param {Number} forgiveness
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroy(forgiveness, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.attendance.forgiveness.Removing Forgiveness")
    );

    api
      .delete(`/ForgivenessPattern/Delete/${forgiveness}`)
      .then((r) => {
        dispatch(_destroySuccess(forgiveness));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.forgiveness Removed Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.forgiveness",
            "Forgiveness",
            app.translate(
              "routes.home.attendance.forgiveness.Removing Forgiveness Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @return {Function}
 */
export function emptyForgivenesses() {
  return _indexSuccess({ data: { forgivenesses: [] }, meta: {} });
}

/**
 *
 * @return {Function}
 */
export function emptyRule() {
  return _showRule({ data: { rule: {} } });
}

// ******************************************************************** forgivenessRules **********************************************************************
/**
 *
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function indexForgivenessRules(forgivenessRuleId , callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`/ForgivenessFactor/GetAll?page=0&limit=100&patternId=${forgivenessRuleId}`,)
      .then((r) => {
        dispatch(_indexForgivenessRulesSuccess(r));
        callback(r);
      })
      .catch((e) => {});
  };
}

/**
 *
 * @param {Number} forgivenessRule
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showForgivenessRule(
  forgivenessRule,
  params = {},
  callback = () => {}
) {
  return (dispatch, gs, api) => {
    api
      .get(`/ForgivenessFactor/GetAll?page=0&limit=100&patternId=${forgivenessRule}`)
      .then((res) => {
        dispatch(_showForgivenessRuleSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        callback(err);
      });
  };
}
/**
 *
 * @param {Number} forgivenessRule
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showEachForgivenessRule(
  forgivenessRule,
  params = {},
  callback = () => {}
) {
  return (dispatch, gs, api) => {
    api
      .get(`/ForgivenessFactor/GetById/${forgivenessRule}`)
      .then((res) => {
        // dispatch(_showForgivenessRuleSuccess(res));
        dispatch(_showEachForgivenessRuleSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function storeForgivenessRule(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate(
        "routes.home.attendance.forgiveness.Adding New ForgivenessRule"
      )
    );

    api
      .post("/ForgivenessFactor/Create",  {data} )
      .then((r) => {
        dispatch(_storeForgivenessRuleSuccess(r));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.forgiveness.New ForgivenessRule Added Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.forgiveness",
            "Forgiveness",
            app.translate(
              "routes.home.attendance.forgiveness.Adding New Forgiveness Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @param {Number} forgivenessRule
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function updateForgivenessRule(forgivenessRule, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate(
        "routes.home.attendance.forgiveness.Updating ForgivenessRule"
      )
    );

    api
      .put(`/forgivenessFactor/Update`, { data })
      .then((r) => {
        dispatch(_updateForgivenessRuleSuccess(r));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.forgiveness.ForgivenessRule Updated Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.forgiveness",
            "Forgiveness",
            app.translate(
              "routes.home.attendance.forgiveness.Updating ForgivenessRule Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @param {Number} forgivenessRule
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroyForgivenessRule(forgivenessRule, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate(
        "routes.home.attendance.forgiveness.Removing ForgivenessRule"
      )
    );

    api
      .delete(`ForgivenessFactor/Delete/${forgivenessRule}`)
      .then((r) => {
        dispatch(_destroyForgivenessRuleSuccess(forgivenessRule));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.forgiveness.ForgivenessRule Removed Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.forgiveness",
            "Forgiveness",
            app.translate(
              "routes.home.attendance.forgiveness.Removing ForgivenessRule Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyForgiveness() {
  return _showSuccess({ data: { forgiveness: {} } });
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyForgivenessRules() {
  return _indexForgivenessRulesSuccess({ data: { forgivenessRules: [] }, meta: {} });
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyForgivenessRule() {
  return _showForgivenessRuleSuccess({ data: { forgivenessRule: {} } });
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(
  state = {
    forgivenesses: [],
    forgiveness: {},
    forgivenessRules: [],
    forgivenessRule: {},
    rule: {},
    metaForgivenesses: {},
    metaForgivenessRules: {},
  },
  action
) {
  let forgivenesses;
  let forgiveness;
  let _index;
  let forgivenessRule;

  switch (action.type) {
    case INDEX_FORGIVENESS_SUCCESS:
      return Object.assign({}, state, {
        forgivenesses: action.payload.data.data,
        metaForgivenesses: action.payload.meta,
      });
    case SHOW_FORGIVENESS_SUCCESS:
      console.log("action.payload.data",action.payload);
      
      return Object.assign({}, state, {
        forgiveness: action.payload,
      });
    case STORE_FORGIVENESS_SUCCESS:
      forgivenesses = app._.cloneDeep(state.forgivenesses);
      forgivenesses.push(action.payload);
      
      return Object.assign({}, state, {
        forgiveness: action.payload,
        forgivenesses,
      });
    case UPDATE_FORGIVENESS_SUCCESS:
      forgivenesses = app._.cloneDeep(state.forgivenesses);
      forgiveness = app._.cloneDeep(state.forgiveness);
      _index = forgivenesses
        ? forgivenesses.findIndex((_forgiveness) => _forgiveness?.id === action?.payload?.id)
        : "";

      forgivenesses[_index] = action?.payload;
      forgiveness.name = action?.payload?.name;
      forgiveness.description = action.payload?.description;
      return Object.assign({}, state, {
        forgiveness,
        forgivenesses,
      });
    case DESTROY_FORGIVENESS_SUCCESS:
      forgivenesses = app._.cloneDeep(state.forgivenesses);
      _index = forgivenesses.findIndex(
        (_forgiveness) => _forgiveness.id === action.payload
      );
      forgivenesses.splice(_index, 1);
      return Object.assign({}, state, {
        forgivenesses,
        forgiveness: null,
        forgivenessRule: null,
      });
    case INDEX_FORGIVENESS_RULES_SUCCESS:
      return Object.assign({}, state, {
        forgivenessRules: action.payload.data.forgivenessRules,
        metaForgivenessRules: action.payload.meta,
      });
    case SHOW_FORGIVENESS_RULE_SUCCESS:
      return Object.assign({}, state, {
        forgiveness:state.forgiveness,
        forgivenessRule: action.payload.data,
      });
    case SHOW_FORGIVENESS_EACH_RULE_SUCCESS:
      return Object.assign({}, state, {
        eachForgivenessRule: action.payload.data,
      });
    case STORE_FORGIVENESS_RULE_SUCCESS:
      forgiveness = app._.cloneDeep(state.forgiveness);
      return Object.assign({}, state, {
        forgivenessRule: action.payload,
        forgiveness,
      });
    case UPDATE_FORGIVENESS_RULE_SUCCESS:
      forgiveness = app._.cloneDeep(state.forgiveness);
      if (forgiveness?.rules) {
        _index = forgiveness.rules.findIndex(
          (_forgivenessRule) => _forgivenessRule.id === action.payload.id
        );
        forgiveness.rules[_index] = action.payload;
      }

      return Object.assign({}, state, {
        forgivenessRule: action.payload,
        forgiveness,
      });
    case DESTROY_FORGIVENESS_RULE_SUCCESS:
      return Object.assign({}, state, {
        forgivenessRule:null,
      });
    case INDEX_FORGIVENESS_RULES_FORM_SUCCESS:
      return Object.assign({}, state, {
        rule: action.payload.rule,
      });
    default:
      return state;
  }
}
